import { useParams } from "react-router-dom";
import { useMemberDetails } from "@/hooks/useMemberDetails";
import { Title } from "@/components/core/Title";
import { useTranslation } from "react-i18next";
import { PageContainer } from "@/components/core/PageContainer";
import { MemberProfileSection } from "@/components/blocks/MemberDetails/MemberProfileSection";
import { ErrorState } from "@/components/core/ErrorState";
import { MemberDetailsSkeleton } from "@/components/blocks/MemberDetails/MemberDetailsSkeleton";
import { Separator } from "@/components/ui/separator";
import { RecentOrders } from "@/components/blocks/MemberDetails/RecentOrders";

export function MemberDetails() {
  const { memberId } = useParams<{ memberId: string }>();
  const { memberDetails, isLoading, isFetching, error, fetchMemberDetails } =
    useMemberDetails(memberId || "");
  const { t } = useTranslation();

  if (error) {
    return (
      <ErrorState
        error={error}
        title={t("customers.memberLoadError")}
        onRetry={() => fetchMemberDetails()}
      />
    );
  }

  if (isLoading || isFetching) {
    return <MemberDetailsSkeleton />;
  }

  if (!memberDetails) {
    return (
      <div className="text-center text-muted-foreground">
        {t("customers.noMemberFound")}
      </div>
    );
  }

  return (
    <PageContainer scrollable className="flex flex-col">
      <Title showBackButton refreshAction={() => fetchMemberDetails()} fallbackUrl="/orders" centeredTitle>
        {t("customers.memberProfile")}
      </Title>

      <MemberProfileSection memberDetails={memberDetails} />

      <Separator />

      <RecentOrders orders={memberDetails.orders} />
    </PageContainer>
  );
}
